import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  de: {
    // Nav / Header
    dashboard_title: 'OddsCortex',
    remaining_tips: 'Verbleibende Tipps',
    admin: 'Admin',
    logout: 'Abmelden',
    settings: 'Einstellungen',
    // Dashboard
    hit_rate: 'Trefferquote',
    tips_used: 'Tipps genutzt',
    correct_tips: 'Richtige Tipps',
    sub_tier: 'Abo-Stufe',
    no_tips: 'Keine Tipps mehr verfügbar',
    upgrade_msg: 'Upgrade dein Abo, um weitere Tipps zu erhalten!',
    upgrade_now: 'Jetzt upgraden',
    available_tips: 'Verfügbare Tipps',
    my_tips: 'Meine Tipps',
    no_available: 'Keine verfügbaren Tipps gefunden. Bitte versuche es später erneut.',
    no_purchased: 'Du hast noch keine Tipps gekauft.',
    no_tips_left: 'Keine Tipps verfügbar',
    buy_tip: 'Tipp kaufen',
    // Auth
    login: 'Anmelden',
    register: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    age_verify: 'Ich bestätige, dass ich 18 Jahre oder älter bin',
    no_account: 'Noch kein Konto? Registrieren',
    has_account: 'Bereits registriert? Anmelden',
    back: 'Zurück',
    loading: 'Lädt...',
    // Pricing
    choose_plan: 'Wähle deinen Plan',
    monthly: 'pro Monat',
    pay_paypal: 'Mit PayPal bezahlen',
    popular: 'BELIEBT',
    tips_per_month: 'AI-Tipps/Monat',
    multi_llm: 'Multi-LLM Analyse',
    detailed_analysis: 'Detaillierte Analysen',
    push_notif: 'Push-Benachrichtigungen',
    // General
    error_loading: 'Fehler beim Laden der Daten',
    legal_warning: 'Wetten können süchtig machen.',
    help_at: 'Hilfe unter',
    adults_only: 'Nur für Erwachsene ab 18 Jahren. Alle Tipps ohne Gewähr.',
    // Tip card
    prediction: 'Vorhersage',
    confidence: 'Vertrauen',
    risk: 'Risiko',
    status: 'Status',
    // Chat
    chat_placeholder: 'Frag mich etwas...',
    chat_greeting: 'Hallo! Ich bin dein OddsCortex Assistent. Frag mich zu Spielen, Tipps oder Wettstrategien.',
    chat_thinking: 'Denkt nach...',
    // Success
    payment_success: 'Zahlung erfolgreich!',
    plan_activated: 'wurde aktiviert.',
    go_to_dashboard: 'Zum Dashboard',
    auto_redirect: 'Automatische Weiterleitung in',
    // Streak
    win_streak: 'Gewinnserie',
    loss_streak: 'Verlustserie',
    best_streak: 'Beste Serie',
    // Profile
    profile: 'Profil',
    stats_per_sport: 'Statistik pro Sportart',
    // Referral
    referral_title: 'Freunde einladen',
    referral_desc: 'Teile deinen Code mit Freunden — ihr bekommt beide Gratis-Tipps!',
    referrals_count: 'Freunde eingeladen',
    tips_per_referral: 'Gratis-Tipps pro Einladung',
    apply_referral: 'Empfehlungscode einlösen',
    apply: 'Einlösen',
    // Analytics
    analytics_title: 'Erweiterte Analysen',
    global_accuracy: 'KI-Genauigkeit (global)',
    accuracy_trend: 'Genauigkeit-Trend',
    first_tip: 'Erster Tipp',
    latest_tip: 'Neuester Tipp',
    live_odds: 'Live-Quoten',
    no_odds: 'Keine Quoten für diese Sportart verfügbar',
    // Feed
    social_feed: 'Community Feed',
    hot_tippers: 'Hot Tipper',
    recent_bets: 'Letzte Wetten',
    no_feed: 'Noch keine Wetten von anderen Nutzern.',
    unlock: 'Freischalten',
    // Leaderboard
    leaderboard: 'Rangliste',
    your_rank: 'Dein Rang',
    of: 'von',
    participants: 'Teilnehmern',
    score: 'Punkte',
    monthly: 'Monatlich',
    all_time: 'Gesamt',
    no_rankings: 'Noch keine Rangliste vorhanden',
    no_rankings_desc: 'Kaufe Tipps um auf der Rangliste zu erscheinen!',
    badges_legend: 'Badge-Legende',
    tips: 'Tipps',
    // Challenges
    challenges: 'Challenges',
    create_challenge: 'Freund herausfordern',
    challenge_desc: 'Fordere einen Freund mit seinem Empfehlungscode zu einem 7-Tage Wett-Duell heraus!',
    challenge_send: 'Herausfordern',
    challenge_prize: '5 Bonus-Tipps für den Gewinner!',
    active_label: 'Aktiv',
    pending_label: 'Wartend',
    completed_label: 'Beendet',
    all_label: 'Alle',
    no_challenges: 'Noch keine Challenges. Fordere jemanden heraus!',
    vs: 'vs',
    you: 'Du',
    time_remaining: 'Verbleibend',
    you_won: 'Gewonnen!',
    bonus_tips: 'Bonus-Tipps',
    has_won: 'hat gewonnen.',
    draw_result: 'Unentschieden!',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    waiting_response: 'Wartet auf Antwort...',
    // Support
    support: 'Support',
    support_title: 'Support',
    priority_support: 'Priority Support',
    ai_support: 'KI-gestützter Support',
    support_placeholder: 'Deine Frage an den Support...',
    support_welcome: 'Wie können wir helfen?',
    support_welcome_desc: 'Wähle eine Kategorie oben und stelle deine Frage. Unser KI-Support antwortet sofort.',
    was_helpful: 'War das hilfreich?',
    // Legal
    impressum: 'Impressum',
    datenschutz: 'Datenschutz',
    agb: 'AGB',
    faq: 'FAQ',
    // AI Council
    ai_council: 'AI Council',
    ai_council_models: 'KI-Modelle aktiv',
    data_points: 'Datenpunkte',
    models: 'Modelle',
    providers: 'Provider',
    hist_data: 'Hist. Daten',
    // Cookie
    cookie_settings: 'Cookie-Einstellungen',
    cookie_accept_all: 'Alle akzeptieren',
    cookie_essential: 'Nur essenzielle',
    // PWA
    install_app: 'App installieren',
    // Notifications
    daily_digest: 'Taeglicher Value-Bet Digest',
    daily_digest_desc: 'Jeden Morgen um 8:00 die besten Value-Bets',
  },
  en: {
    dashboard_title: 'OddsCortex',
    remaining_tips: 'Tips Remaining',
    admin: 'Admin',
    logout: 'Logout',
    settings: 'Settings',
    hit_rate: 'Hit Rate',
    tips_used: 'Tips Used',
    correct_tips: 'Correct Tips',
    sub_tier: 'Plan',
    no_tips: 'No tips remaining',
    upgrade_msg: 'Upgrade your plan to get more tips!',
    upgrade_now: 'Upgrade now',
    available_tips: 'Available Tips',
    my_tips: 'My Tips',
    no_available: 'No available tips found. Please try again later.',
    no_purchased: 'You have not purchased any tips yet.',
    no_tips_left: 'No tips available',
    buy_tip: 'Buy Tip',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    age_verify: 'I confirm that I am 18 years or older',
    no_account: "Don't have an account? Register",
    has_account: 'Already registered? Login',
    back: 'Back',
    loading: 'Loading...',
    choose_plan: 'Choose your Plan',
    monthly: 'per month',
    pay_paypal: 'Pay with PayPal',
    popular: 'POPULAR',
    tips_per_month: 'AI tips/month',
    multi_llm: 'Multi-LLM Analysis',
    detailed_analysis: 'Detailed Analysis',
    push_notif: 'Push Notifications',
    error_loading: 'Error loading data',
    legal_warning: 'Gambling can be addictive.',
    help_at: 'Help at',
    adults_only: 'Adults 18+ only. All tips without guarantee.',
    prediction: 'Prediction',
    confidence: 'Confidence',
    risk: 'Risk',
    status: 'Status',
    chat_placeholder: 'Ask me something...',
    chat_greeting: "Hi! I'm your OddsCortex assistant. Ask me about games, tips or strategies.",
    chat_thinking: 'Thinking...',
    payment_success: 'Payment successful!',
    plan_activated: 'has been activated.',
    go_to_dashboard: 'Go to Dashboard',
    auto_redirect: 'Auto redirect in',
    win_streak: 'Win Streak',
    loss_streak: 'Loss Streak',
    best_streak: 'Best Streak',
    profile: 'Profile',
    stats_per_sport: 'Stats per Sport',
    referral_title: 'Invite Friends',
    referral_desc: 'Share your code with friends — you both get free tips!',
    referrals_count: 'Friends invited',
    tips_per_referral: 'Free tips per invite',
    apply_referral: 'Redeem referral code',
    apply: 'Redeem',
    analytics_title: 'Advanced Analytics',
    global_accuracy: 'AI Accuracy (global)',
    accuracy_trend: 'Accuracy Trend',
    first_tip: 'First Tip',
    latest_tip: 'Latest Tip',
    live_odds: 'Live Odds',
    no_odds: 'No odds available for this sport',
    social_feed: 'Community Feed',
    hot_tippers: 'Hot Tippers',
    recent_bets: 'Recent Bets',
    no_feed: 'No bets from other users yet.',
    unlock: 'Unlock',
    leaderboard: 'Leaderboard',
    your_rank: 'Your Rank',
    of: 'of',
    participants: 'participants',
    score: 'Score',
    monthly: 'Monthly',
    all_time: 'All Time',
    no_rankings: 'No rankings yet',
    no_rankings_desc: 'Buy tips to appear on the leaderboard!',
    badges_legend: 'Badge Legend',
    tips: 'Tips',
    challenges: 'Challenges',
    create_challenge: 'Challenge a Friend',
    challenge_desc: 'Challenge a friend with their referral code to a 7-day betting duel!',
    challenge_send: 'Challenge',
    challenge_prize: '5 bonus tips for the winner!',
    active_label: 'Active',
    pending_label: 'Pending',
    completed_label: 'Completed',
    all_label: 'All',
    no_challenges: 'No challenges yet. Challenge someone!',
    vs: 'vs',
    you: 'You',
    time_remaining: 'Remaining',
    you_won: 'You won!',
    bonus_tips: 'Bonus tips',
    has_won: 'won.',
    draw_result: 'Draw!',
    accept: 'Accept',
    decline: 'Decline',
    waiting_response: 'Waiting for response...',
    // Support
    support: 'Support',
    support_title: 'Support',
    priority_support: 'Priority Support',
    ai_support: 'AI-powered Support',
    support_placeholder: 'Your question...',
    support_welcome: 'How can we help?',
    support_welcome_desc: 'Select a category and ask your question. Our AI support responds instantly.',
    was_helpful: 'Was this helpful?',
    // Legal
    impressum: 'Legal Notice',
    datenschutz: 'Privacy Policy',
    agb: 'Terms of Service',
    faq: 'FAQ',
    // AI Council
    ai_council: 'AI Council',
    ai_council_models: 'AI models active',
    data_points: 'Data Points',
    models: 'Models',
    providers: 'Providers',
    hist_data: 'Hist. Data',
    // Cookie
    cookie_settings: 'Cookie Settings',
    cookie_accept_all: 'Accept all',
    cookie_essential: 'Essential only',
    // PWA
    install_app: 'Install App',
    // Notifications
    daily_digest: 'Daily Value-Bet Digest',
    daily_digest_desc: 'Every morning at 8:00 the best value bets',
  },
  fr: {
    dashboard_title: 'OddsCortex',
    welcome: 'Bienvenue',
    loading: 'Chargement...',
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Deconnexion',
    email: 'E-mail',
    password: 'Mot de passe',
    tips: 'Conseils',
    analytics: 'Analyses',
    leaderboard: 'Classement',
    profile: 'Profil',
    settings: 'Parametres',
    subscription: 'Abonnement',
    upgrade: 'Ameliorer',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    no_tips: 'Aucun conseil disponible',
    pay_paypal: 'Payer avec PayPal',
    sport: 'Sport',
    league: 'Ligue',
    confidence: 'Confiance',
    prediction: 'Prediction',
    impressum: 'Mentions legales',
    datenschutz: 'Politique de confidentialite',
    agb: 'CGU',
    faq: 'FAQ',
    support: 'Support',
    challenges: 'Defis',
    messages: 'Messages',
    follow: 'Suivre',
    unfollow: 'Se desabonner',
    tipster_of_day: 'Tipster du jour',
  },
  es: {
    dashboard_title: 'OddsCortex',
    welcome: 'Bienvenido',
    loading: 'Cargando...',
    login: 'Iniciar sesion',
    register: 'Registrarse',
    logout: 'Cerrar sesion',
    email: 'Correo',
    password: 'Contrasena',
    tips: 'Consejos',
    analytics: 'Analiticas',
    leaderboard: 'Clasificacion',
    profile: 'Perfil',
    settings: 'Ajustes',
    subscription: 'Suscripcion',
    upgrade: 'Mejorar',
    back: 'Volver',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    no_tips: 'No hay consejos disponibles',
    pay_paypal: 'Pagar con PayPal',
    sport: 'Deporte',
    league: 'Liga',
    confidence: 'Confianza',
    prediction: 'Prediccion',
    impressum: 'Aviso legal',
    datenschutz: 'Politica de privacidad',
    agb: 'Terminos',
    faq: 'FAQ',
    support: 'Soporte',
    challenges: 'Desafios',
    messages: 'Mensajes',
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    tipster_of_day: 'Tipster del dia',
  },
  it: {
    dashboard_title: 'OddsCortex',
    welcome: 'Benvenuto',
    loading: 'Caricamento...',
    login: 'Accedi',
    register: 'Registrati',
    logout: 'Esci',
    email: 'E-mail',
    password: 'Password',
    tips: 'Suggerimenti',
    analytics: 'Analisi',
    leaderboard: 'Classifica',
    profile: 'Profilo',
    settings: 'Impostazioni',
    subscription: 'Abbonamento',
    upgrade: 'Aggiorna',
    back: 'Indietro',
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    no_tips: 'Nessun suggerimento disponibile',
    pay_paypal: 'Paga con PayPal',
    sport: 'Sport',
    league: 'Campionato',
    confidence: 'Fiducia',
    prediction: 'Previsione',
    impressum: 'Note legali',
    datenschutz: 'Privacy',
    agb: 'Termini',
    faq: 'FAQ',
    support: 'Assistenza',
    challenges: 'Sfide',
    messages: 'Messaggi',
    follow: 'Segui',
    unfollow: 'Smetti di seguire',
    tipster_of_day: 'Tipster del giorno',
  },
  tr: {
    dashboard_title: 'OddsCortex',
    welcome: 'Hos geldiniz',
    loading: 'Yukleniyor...',
    login: 'Giris yap',
    register: 'Kayit ol',
    logout: 'Cikis',
    email: 'E-posta',
    password: 'Sifre',
    tips: 'Tahminler',
    analytics: 'Analizler',
    leaderboard: 'Siralama',
    profile: 'Profil',
    settings: 'Ayarlar',
    subscription: 'Abonelik',
    upgrade: 'Yukselt',
    back: 'Geri',
    save: 'Kaydet',
    cancel: 'Iptal',
    confirm: 'Onayla',
    no_tips: 'Mevcut tahmin yok',
    pay_paypal: 'PayPal ile ode',
    sport: 'Spor',
    league: 'Lig',
    confidence: 'Guven',
    prediction: 'Tahmin',
    impressum: 'Yasal bilgi',
    datenschutz: 'Gizlilik',
    agb: 'Kosullar',
    faq: 'SSS',
    support: 'Destek',
    challenges: 'Meydan okuma',
    messages: 'Mesajlar',
    follow: 'Takip et',
    unfollow: 'Takibi birak',
    tipster_of_day: 'Gunun tipsteri',
  },
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'de');

  const switchLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('lang', l);
  }, []);

  const t = useCallback((key) => translations[lang]?.[key] || translations.de[key] || key, [lang]);

  return (
    <LangContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
